module.exports = __webpack_public_path__ + "img/PCM_Booth_Diamond_people_version_A2_4x3.111c96b8.png";